import { render, staticRenderFns } from "./levelModification.vue?vue&type=template&id=3fe64798&scoped=true&"
import script from "./levelModification.vue?vue&type=script&lang=js&"
export * from "./levelModification.vue?vue&type=script&lang=js&"
import style0 from "./levelModification.vue?vue&type=style&index=0&id=3fe64798&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe64798",
  null
  
)

export default component.exports